module.exports = __webpack_public_path__ + "static/media/product7.70246883.jpg";